const getGiveawaySessionsResponse = (response) => {
  return response?.data?.giveawaySessions ?? [];
};

export default getGiveawaySessionsResponse;
